export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-01.8dd2e7fd.png";